import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import "./Home.css";
import heroImg from "./assets/hero-img.png";
import { Link } from "react-router-dom";
import pig from "./assets/pig.png";
import thumbOne from "./assets/website-conversion-tn.png";
import thumbTwo from "./assets/accounting-firm-rebrand-tn.png";
import thumbThree from "./assets/cpa-frim-tn.png";

import updateIcon from "./assets/update-icon.png";
import errorIcon from "./assets/error-icon.png";
import clientIcon from "./assets/client-first-icon.png";
import webManagementValidationImg from "./assets/web-managenet-validation.png";
import webGrowthValidationImg from "./assets/web-growth-validation.png";

const Home = () => {
  const [email, setEmail] = useState("");
  const [showError, setShowError] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(null);

  const handleEmailSubmit = () => {
    if (email) {
      setShowError(false);

      const mailtoLink = `mailto:attoli@outlook.com?subject=${encodeURIComponent(
        "Excited to Connect!",
      )}&body=${encodeURIComponent(`Hi attoli Team,`)}`;
      window.location.href = mailtoLink;

      setEmail("");
    } else {
      setShowError(true);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (showError) {
      setShowError(false);
    }
  };

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="app-container">
      <Helmet>
        <meta
          name="description"
          content="Professional website growth & management services. Improve your sites growth, drive more traffic, and grow your business with attoli."
        />
        <title>Attoli</title>
        <link rel="canonical" href="https://attoli.com" />
      </Helmet>
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              CPA Marketing
              <span className="hero-accent"> That Helps Your Firm Grow </span>
            </h1>
            <p className="hero-description">
              Built and managed websites for solo accountants and small
              accounting firms. More visibility. More clients. Less stress.
            </p>
            <Link to="/contact" rel="noopener noreferrer" className="hero-link">
              <button className="button hero-GST-btn">
                <span className="GST-text">Grow Today</span>
                <span className="svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="20"
                    viewBox="0 0 38 15"
                    fill="none"
                  >
                    <path
                      fill="white"
                      d="M10 7.519l-.939-.344h0l.939.344zm14.386-1.205l-.981-.192.981.192zm1.276 5.509l.537.843.148-.094.107-.139-.792-.611zm4.819-4.304l-.385-.923h0l.385.923zm7.227.707a1 1 0 0 0 0-1.414L31.343.448a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364zM1 7.519l.554.833.029-.019.094-.061.361-.23 1.277-.77c1.054-.609 2.397-1.32 3.629-1.787.617-.234 1.17-.392 1.623-.455.477-.066.707-.008.788.034.025.013.031.021.039.034a.56.56 0 0 1 .058.235c.029.327-.047.906-.39 1.842l1.878.689c.383-1.044.571-1.949.505-2.705-.072-.815-.45-1.493-1.16-1.865-.627-.329-1.358-.332-1.993-.244-.659.092-1.367.305-2.056.566-1.381.523-2.833 1.297-3.921 1.925l-1.341.808-.385.245-.104.068-.028.018c-.011.007-.011.007.543.84zm8.061-.344c-.198.54-.328 1.038-.36 1.484-.032.441.024.94.325 1.364.319.45.786.64 1.21.697.403.054.824-.001 1.21-.09.775-.179 1.694-.566 2.633-1.014l3.023-1.554c2.115-1.122 4.107-2.168 5.476-2.524.329-.086.573-.117.742-.115s.195.038.161.014c-.15-.105.085-.139-.076.685l1.963.384c.192-.98.152-2.083-.74-2.707-.405-.283-.868-.37-1.28-.376s-.849.069-1.274.179c-1.65.43-3.888 1.621-5.909 2.693l-2.948 1.517c-.92.439-1.673.743-2.221.87-.276.064-.429.065-.492.057-.043-.006.066.003.155.127.07.099.024.131.038-.063.014-.187.078-.49.243-.94l-1.878-.689zm14.343-1.053c-.361 1.844-.474 3.185-.413 4.161.059.95.294 1.72.811 2.215.567.544 1.242.546 1.664.459a2.34 2.34 0 0 0 .502-.167l.15-.076.049-.028.018-.011c.013-.008.013-.008-.524-.852l-.536-.844.019-.012c-.038.018-.064.027-.084.032-.037.008.053-.013.125.056.021.02-.151-.135-.198-.895-.046-.734.034-1.887.38-3.652l-1.963-.384zm2.257 5.701l.791.611.024-.031.08-.101.311-.377 1.093-1.213c.922-.954 2.005-1.894 2.904-2.27l-.771-1.846c-1.31.547-2.637 1.758-3.572 2.725l-1.184 1.314-.341.414-.093.117-.025.032c-.01.013-.01.013.781.624zm5.204-3.381c.989-.413 1.791-.42 2.697-.307.871.108 2.083.385 3.437.385v-2c-1.197 0-2.041-.226-3.19-.369-1.114-.139-2.297-.146-3.715.447l.771 1.846z"
                    ></path>
                  </svg>
                </span>
              </button>
            </Link>
          </div>

          <div className="hero-image-container">
            <img
              src={heroImg}
              alt="Cartoon character of a lady lying on her stomach working on her laptop"
              className="hero-mailbox-image"
            />
          </div>
        </div>
      </section>

      <section className="scroll-prompt-section">
        <div className="scroll-prompt-container">
          <h2 className="scroll-prompt-title">
            Bet you didn't know that these help grow your accounting site
          </h2>
          <div className="scroll-prompt-grid">
            <div className="scroll-prompt-card">
              <img
                src={updateIcon}
                alt="Update icon"
                className="scroll-prompt-icon"
              />
              <h3>Updates</h3>
              <p>
                Your website should work like an employee bringing in new
                clients, not a brochure that sits online collecting dust.
              </p>
            </div>
            <div className="scroll-prompt-card">
              <img
                src={errorIcon}
                alt="Error icon"
                className="scroll-prompt-icon"
              />
              <h3>Minor Issues</h3>
              <p>
                Small site issues can cost you new clients without you realizing
                it. We can help you manage your site to help make sure your
                first impression builds confidence.
              </p>
            </div>
            <div className="scroll-prompt-card">
              <img
                src={clientIcon}
                alt="Client icon"
                className="scroll-prompt-icon"
              />
              <h3>Clients First</h3>
              <p>
                Your time is better spent serving clients and growing your firm
                while someone else keeps your online presence growing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="resource-links-section"
        aria-label="Accounting website growth resources"
      >
        <h2 className="resource-links-title">Top Website Growth Resources</h2>

        <div className="resource-links-grid">
          <div className="resource-block resource-block-large">
            <img
              src={pig}
              alt="Start-up accounting resource"
              className="resource-image resource-image-large"
            />

            <h3 className="resource-title">
              <Link
                to="https://attoli.com/content/marketing-for-accounting-firms"
                target="_blank"
              >
                How Marketing for Accounting Firms Is Easy on a Budget
              </Link>
              <p>
                Marketing your accounting firm doesn't require a big budget,
                just consistent, low-cost strategies like content marketing,
                referrals, social media, and client testimonials to steadily
                attract new clients.
              </p>
            </h3>
          </div>

          <div className="resource-block-stack">
            <div className="resource-block resource-block-small">
              <img
                src={thumbOne}
                alt="Accounting SEO resource"
                className="resource-image resource-image-small"
              />
              <h3 className="resource-thumb-title">
                <Link
                  to="https://attoli.com/content/accounting-website-conversion"
                  target="_blank"
                >
                  Why Your Website Isn't Turning Visitors Into Leads
                </Link>
                <p className="resource-thumb-text">
                  Boost accounting website conversions with clear CTAs, shorter
                  forms, trust signals, faster pages, and A/B testing.
                </p>
              </h3>
            </div>

            <div className="resource-block resource-block-small">
              <img
                src={thumbTwo}
                alt="Accounting SEO resource"
                className="resource-image resource-image-small"
              />
              <h3 className="resource-thumb-title">
                <Link
                  to="https://attoli.com/content/accounting-firm-rebrand"
                  target="_blank"
                >
                  Rebranding An Accounting Firm Before You Sell
                </Link>
                <p className="resource-thumb-text">
                  Build a firm-first brand with evergreen content to increase
                  long-term value and make your accounting practice easier to
                  sell.
                </p>
              </h3>
            </div>

            <div className="resource-block resource-block-small">
              <img
                src={thumbThree}
                alt="Accounting SEO resource"
                className="resource-image resource-image-small"
              />
              <h3 className="resource-thumb-title">
                <Link
                  to="https://attoli.com/content/cpa-firm-websites"
                  target="_blank"
                >
                  Do CPA Firm Websites Still Matter From Referrals?
                </Link>
                <p className="resource-thumb-text">
                  A strong website helps referral leads convert, protecting
                  low-cost client acquisition and supporting steady firm growth.
                </p>
              </h3>
            </div>
          </div>
        </div>
      </section>

      <section className="wm-validation-section">
        <div className="wm-validation-content">
          <div className="wm-validation-copy">
            <h2 className="wm-validation-title">Website Management</h2>
            <p className="wm-validation-description">
              Keep your site strong so it stays ready to turn visitors into
              clients.
            </p>
            <ul className="wm-validation-list">
              <li>
                Keep your site updated with fresh content and clear messages
              </li>
              <li>
                Catch small problems early before they hurt trust or sales
              </li>
              <li>Make sure your site gives new clients a great first look</li>
              <li>
                Watch your site speed and links so nothing slows visitors down
              </li>
            </ul>
            <Link
              to="/services/website-management-services"
              rel="noopener noreferrer"
              className="hero-link"
            >
              <button className="button hero-GST-btn">
                <span className="GST-text">Learn More</span>
                <span className="svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="20"
                    viewBox="0 0 38 15"
                    fill="none"
                  >
                    <path
                      fill="white"
                      d="M10 7.519l-.939-.344h0l.939.344zm14.386-1.205l-.981-.192.981.192zm1.276 5.509l.537.843.148-.094.107-.139-.792-.611zm4.819-4.304l-.385-.923h0l.385.923zm7.227.707a1 1 0 0 0 0-1.414L31.343.448a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364zM1 7.519l.554.833.029-.019.094-.061.361-.23 1.277-.77c1.054-.609 2.397-1.32 3.629-1.787.617-.234 1.17-.392 1.623-.455.477-.066.707-.008.788.034.025.013.031.021.039.034a.56.56 0 0 1 .058.235c.029.327-.047.906-.39 1.842l1.878.689c.383-1.044.571-1.949.505-2.705-.072-.815-.45-1.493-1.16-1.865-.627-.329-1.358-.332-1.993-.244-.659.092-1.367.305-2.056.566-1.381.523-2.833 1.297-3.921 1.925l-1.341.808-.385.245-.104.068-.028.018c-.011.007-.011.007.543.84zm8.061-.344c-.198.54-.328 1.038-.36 1.484-.032.441.024.94.325 1.364.319.45.786.64 1.21.697.403.054.824-.001 1.21-.09.775-.179 1.694-.566 2.633-1.014l3.023-1.554c2.115-1.122 4.107-2.168 5.476-2.524.329-.086.573-.117.742-.115s.195.038.161.014c-.15-.105.085-.139-.076.685l1.963.384c.192-.98.152-2.083-.74-2.707-.405-.283-.868-.37-1.28-.376s-.849.069-1.274.179c-1.65.43-3.888 1.621-5.909 2.693l-2.948 1.517c-.92.439-1.673.743-2.221.87-.276.064-.429.065-.492.057-.043-.006.066.003.155.127.07.099.024.131.038-.063.014-.187.078-.49.243-.94l-1.878-.689zm14.343-1.053c-.361 1.844-.474 3.185-.413 4.161.059.95.294 1.72.811 2.215.567.544 1.242.546 1.664.459a2.34 2.34 0 0 0 .502-.167l.15-.076.049-.028.018-.011c.013-.008.013-.008-.524-.852l-.536-.844.019-.012c-.038.018-.064.027-.084.032-.037.008.053-.013.125.056.021.02-.151-.135-.198-.895-.046-.734.034-1.887.38-3.652l-1.963-.384zm2.257 5.701l.791.611.024-.031.08-.101.311-.377 1.093-1.213c.922-.954 2.005-1.894 2.904-2.27l-.771-1.846c-1.31.547-2.637 1.758-3.572 2.725l-1.184 1.314-.341.414-.093.117-.025.032c-.01.013-.01.013.781.624zm5.204-3.381c.989-.413 1.791-.42 2.697-.307.871.108 2.083.385 3.437.385v-2c-1.197 0-2.041-.226-3.19-.369-1.114-.139-2.297-.146-3.715.447l.771 1.846z"
                    ></path>
                  </svg>
                </span>
              </button>
            </Link>
          </div>
          <div className="wm-validation-image-wrap">
            <img
              src={webManagementValidationImg}
              alt="Website management validation illustration"
              className="wm-validation-image"
            />
          </div>
        </div>
      </section>

      <section className="wg-validation-section">
        <div className="wg-validation-content">
          <div className="wg-validation-copy">
            <h2 className="wg-validation-title">Website Growth</h2>
            <p className="wg-validation-description">
              Grow your traffic and turn more visitors into paying clients.
            </p>
            <ul className="wg-validation-list">
              <li>
                Write blog posts that target the exact words your future clients
                search for
              </li>

              <li>
                Build trust with search engines through steady content updates
              </li>
              <li>Use data to find new topics and keywords worth targeting</li>
              <li>
                Grow your reach with content that answers real client questions
              </li>
            </ul>
            <Link
              to="/services/digital-growth-for-accountants"
              rel="noopener noreferrer"
              className="hero-link"
            >
              <button className="button hero-GST-btn">
                <span className="GST-text">Learn More</span>
                <span className="svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="20"
                    viewBox="0 0 38 15"
                    fill="none"
                  >
                    <path
                      fill="white"
                      d="M10 7.519l-.939-.344h0l.939.344zm14.386-1.205l-.981-.192.981.192zm1.276 5.509l.537.843.148-.094.107-.139-.792-.611zm4.819-4.304l-.385-.923h0l.385.923zm7.227.707a1 1 0 0 0 0-1.414L31.343.448a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364zM1 7.519l.554.833.029-.019.094-.061.361-.23 1.277-.77c1.054-.609 2.397-1.32 3.629-1.787.617-.234 1.17-.392 1.623-.455.477-.066.707-.008.788.034.025.013.031.021.039.034a.56.56 0 0 1 .058.235c.029.327-.047.906-.39 1.842l1.878.689c.383-1.044.571-1.949.505-2.705-.072-.815-.45-1.493-1.16-1.865-.627-.329-1.358-.332-1.993-.244-.659.092-1.367.305-2.056.566-1.381.523-2.833 1.297-3.921 1.925l-1.341.808-.385.245-.104.068-.028.018c-.011.007-.011.007.543.84zm8.061-.344c-.198.54-.328 1.038-.36 1.484-.032.441.024.94.325 1.364.319.45.786.64 1.21.697.403.054.824-.001 1.21-.09.775-.179 1.694-.566 2.633-1.014l3.023-1.554c2.115-1.122 4.107-2.168 5.476-2.524.329-.086.573-.117.742-.115s.195.038.161.014c-.15-.105.085-.139-.076.685l1.963.384c.192-.98.152-2.083-.74-2.707-.405-.283-.868-.37-1.28-.376s-.849.069-1.274.179c-1.65.43-3.888 1.621-5.909 2.693l-2.948 1.517c-.92.439-1.673.743-2.221.87-.276.064-.429.065-.492.057-.043-.006.066.003.155.127.07.099.024.131.038-.063.014-.187.078-.49.243-.94l-1.878-.689zm14.343-1.053c-.361 1.844-.474 3.185-.413 4.161.059.95.294 1.72.811 2.215.567.544 1.242.546 1.664.459a2.34 2.34 0 0 0 .502-.167l.15-.076.049-.028.018-.011c.013-.008.013-.008-.524-.852l-.536-.844.019-.012c-.038.018-.064.027-.084.032-.037.008.053-.013.125.056.021.02-.151-.135-.198-.895-.046-.734.034-1.887.38-3.652l-1.963-.384zm2.257 5.701l.791.611.024-.031.08-.101.311-.377 1.093-1.213c.922-.954 2.005-1.894 2.904-2.27l-.771-1.846c-1.31.547-2.637 1.758-3.572 2.725l-1.184 1.314-.341.414-.093.117-.025.032c-.01.013-.01.013.781.624zm5.204-3.381c.989-.413 1.791-.42 2.697-.307.871.108 2.083.385 3.437.385v-2c-1.197 0-2.041-.226-3.19-.369-1.114-.139-2.297-.146-3.715.447l.771 1.846z"
                    ></path>
                  </svg>
                </span>
              </button>
            </Link>
          </div>
          <div className="wg-validation-image-wrap">
            <img
              src={webGrowthValidationImg}
              alt="Website growth validation illustration"
              className="wg-validation-image"
            />
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-content">
          <h2 className="contact-title">
            Ready to Get Started with Site Growth?
          </h2>
          <p className="contact-description">
            Let's talk about how Attoli can help you grow your business online.
            Book a free audit and discover how the right strategy can unlock
            sustainable growth and long-term success with better SEO site
            ranking.
          </p>

          <div className="email-form">
            {showError && (
              <div className="error-message">
                Please enter your email address first.
              </div>
            )}

            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Enter your email address"
              className="email-input"
            />
            <button onClick={handleEmailSubmit} className="contact-btn">
              Contact
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
